import { mapState } from 'vuex'
import router from '@/router'
import { getReimburseTypeByCode } from '@/api/budget/reimbursementType'
import ECSBillRoutingGuide from '@/components/ecs-bill-routing-guide'
import { isFeishuMiniAppEnv, containsKeywords } from '@/utils'
/**
 * 关闭页面返回刷新列表
 */
export const CloseToRefreshList = {
  /**
   * 路由离开时，设置目标页是否需要刷新列表
   * @param {*} to
   * @param {*} from
   * @param {*} next
   */
  beforeRouteLeave(to, from, next) {
    const fromNeedRefreshList = from.meta?.needRefreshList
    // needRefreshList 没有定义在data中，是因为它只作为一个普通变量，无需响应式
    if (!this?.needRefreshList && !fromNeedRefreshList) return next()
    to.meta.needRefreshList = this?.needRefreshList || fromNeedRefreshList
    from.meta.needRefreshList = false
    next()
  },
  methods: {
    /**
     * 关闭当前页（跳转到指定页面）
     * @param {string | Location} to 可选参数,与路由对象的`push`方法入参一致，如果未指定 `to`,则默认打开前一个标签
     * @example
     * this.closeSelf('/xxx')
     * this.closeSelf(this.$route)
     * @returns
     */
    async closeSelf(to) {
      if (isFeishuMiniAppEnv) {
        const approvalButton = document.querySelector('button[data-key=APPROVAL]')
        const rejectButton = document.querySelector('button[data-key=RETURN]')
        if (approvalButton) {
          approvalButton.classList.add('is-disabled')
          approvalButton.style.pointerEvents = 'none'
        }
        if (rejectButton) {
          rejectButton.classList.add('is-disabled')
          rejectButton.style.pointerEvents = 'none'
        }
        return
      }
      await this.$mgCloseEditPageConfirm(this.$route.name)
      const visiteRoutes = this.$store.getters['tabsBar/visiteRoutes']
      if (to && !(to instanceof Event)) {
        let location = this.$router.match(to)
        if (location.path !== this.$route.path) {
          const targetRoute = visiteRoutes.find((item) => item.path === location.path)
          if (targetRoute) location = targetRoute
          this.$store.dispatch('tabsBar/removeTab', this.$route)
          this.$router.push(location)
          return
        }
      }
      // 未指定目标路由走默认逻辑
      const index = visiteRoutes.findIndex((item) => item.path === this.$route.path)
      const toRoute = visiteRoutes[index - 1] || visiteRoutes[index + 1]
      if (toRoute) this.$router.push(toRoute)
      this.$store.dispatch('tabsBar/removeTab', visiteRoutes[index])
    },
  },
}

export const StoreState = {
  computed: {
    ...mapState({
      common: (state) => state.common,
      dict: (state) => state.dict,
    }),
  },
}

export const DynamicRoutingMixin = {
  methods: {
    /**
     * 不依赖侧边栏权限，根据工作流返回路由地址进行跳转
     * @param { String } routeUrl 工作流配置的路由
     * @returns
     */
    handleWorkflowRoute({ routeUrl = '' } = {}) {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            if (!routeUrl) return this.$mgMessage('当前地址有误，请核对后重试', 'error')
            const matchRoute = this.$router.match(routeUrl)
            if (matchRoute.path === '/404') {
              const permissionsAllMenus = this.$store.getters['user/permissionsAllMenus']
              const workflowConfigRoutes = await this.$store.dispatch('routes/setWorkflowConfigRoutes', {
                routes: permissionsAllMenus[0].children,
                workflowRoutes: [routeUrl],
              })
              workflowConfigRoutes?.forEach((route) => router.addRoute(route))
            }
            await this.$router.push(routeUrl)
            resolve()
          } catch (error) {
            reject(error)
          }
        })()
      })
    },
  },
}

export const ApprovalTypeValidateMixin = {
  // components: { ECSBillRoutingGuide },
  data() {
    return {
      reimburseTypeConfig: {
        enableRouteBill: false,
        // 股份、办公、礼品、佳美、美新、华南、湖北潮信、晨讯、新加坡、奇只好玩、上海晨光信息科技有限公司、上海晨光在线甄选文具有限公司
        includeCompanyCodes: ['1', '2', '5', 'MG9001', '060', '069', 'MG9004', 'MG9002', '062764', '065', '042', 'MG9008'],
      },
    }
  },

  created() {
    // if (this.form.reimburseTypeCode) {
    //   getReimburseTypeByCode(this.form.reimburseTypeCode).then((res) => {
    //     this.reimburseTypeConfig.enableRouteBill = res.data.enableRouteBill
    //   })
    // }
  },
  methods: {
    /**
     * 单据需要显示的审批类型
     *
     * 可选值：
     * 'ELECTRONIC': '电子流',
     * 'PAPER': '纸质流'
     */
    queryApprovalTagType(approvalTagType = null) {
      const approvalTagTypes = {
        ELECTRONIC: '电子流',
        PAPER: '纸质流',
      }
      if (approvalTagType in approvalTagTypes) {
        return `【${approvalTagTypes[approvalTagType]}】`
      }
      return ''
    },

    isMatchCompany(companyCodeField = '', companyNameField = '') {
      // 兼容不同单据不同字段
      let code = '', name = '';
      if (companyCodeField && companyNameField) {
        code = this.form?.[companyCodeField] || ''
        name = this.form?.[companyNameField] || ''
      } else {
        code = this.form?.payCompanyCode ?? this.form?.payCompany?.companyCode ?? ''
        name = this.form?.payCompanyName ?? this.form?.payCompany?.companyName ?? ''
      }
      return this.reimburseTypeConfig.includeCompanyCodes.includes(code) || containsKeywords({ str: name })
    },

    /**
     * 提交时自动判断单据流类型为“电子流”or“纸质流”
     */
    async automaticJudgmentApprovalType(attachmentField = 'attachmentList') {
      /**
       *注释原因如下：
       *修改区域：if (!this.isMatchCompany()) return Promise.resolve()
       *修改版本V1.0.0
       *修改时间：2026-07-17
       *修改分支：ecs-zws-voucher
       *修改需求：杂物社凭证自动化&无纸化：按照杂物社的凭证规则，将费控的杂物社相关的报销单自动按照凭证规则生成会计凭证到金蝶总账系统。
       *
       *放开原因如下：
       *修改区域：if (!this.isMatchCompany()) return Promise.resolve()
       *修改版本V1.0.1
       *修改时间：2026-08-04
       *修改分支：hotfix-0804-cw
       *修改需求：杂物社凭证自动化&无纸化：按照杂物社的凭证规则，再次放开指定公司的判断，并增加code: “'042', 'MG9008'和name: '九木杂物社'”的公司判断，确保杂物社相关的报销单自动按照凭证规则生成会计凭证到金蝶总账系统。
       */
      if (!this.isMatchCompany()) return Promise.resolve()
      const hasAttachment = !!this.form[attachmentField]?.length
      const hasInvoice = !!this.form?.invoiceList?.length
      let message = ''

      // 无票场景
      if (!hasInvoice) {
        message = hasAttachment
          ? '您本次提交的流程无需打印报销单和各类附件，若附件中存在报价单/对账单/结算单/检测报告/验收单等原件请申请人妥善保管。'
          : '您本次提交的流程无需打印报销单和各类附件。'
      } else {
        // 发票全部为电子票场景
        if (this.form?.invoiceList?.every((item) => item.electronicMark == '1')) {
          message = hasAttachment
            ? '您本次提交的报销单均为电子发票，您无需打印报销单、发票和各类附件，无需交纸质单。\n另：附件中如存在报价单/对账单/结算单/检测报告/验收单等原件请申请人妥善保管。'
            : '您本次提交的报销单均为电子发票，您无需打印报销单和发票，无需交纸质单。'
        }

        // 发票全部为纸质发票
        if (this.form?.invoiceList?.every((item) => item.electronicMark != '1')) {
          message = hasAttachment
            ? '您本次提交的报销单均为纸质发票或收据，需要打印报销单、提交纸质发票/纸质收据。\n附件无需打印，若附件中存在报价单/对账单/结算单/检测报告/验收单等原件请申请人妥善保管。'
            : '您本次提交的报销单均为纸质发票或收据，需要打印报销单并提交纸质发票/纸质收据。'
        }

        // 发票存在纸质发票
        if (this.form?.invoiceList?.some((item) => item.electronicMark != '1')) {
          const paperInvoices = this.form?.invoiceList?.filter((item) => item.electronicMark != '1') || []
          message = hasAttachment
            ? `您本次提交的报销单其中有${paperInvoices.length}张为纸质发票，发票号为${paperInvoices
                .map((i) => i.number)
                .join(
                  '，'
                )}。需打印报销单、提交纸质发票/纸质收据，其余电子发票无需打印。\n若附件中存在报价单/对账单/结算单/检测报告/验收单等原件请申请部门妥善保管。`
            : `您本次提交的报销单其中有${paperInvoices.length}张为纸质发票，发票号为${paperInvoices
                .map((i) => i.number)
                .join('，')}。需打印报销单、提交纸质发票/纸质收据，其余电子发票无需打印`
        }
      }

      await this.$mgConfirm(message, '提示', { confirmButtonText: '关闭', showCancelButton: false })
      return Promise.resolve()
    },
  },
}
